import { render, staticRenderFns } from "./TableBalanceHistory.vue?vue&type=template&id=19b83dc4&"
import script from "./TableBalanceHistory.vue?vue&type=script&lang=js&"
export * from "./TableBalanceHistory.vue?vue&type=script&lang=js&"
import style0 from "./TableBalanceHistory.vue?vue&type=style&index=0&id=19b83dc4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports